const firebaseConfig = {
   apiKey: "AIzaSyCvfPduxjUO1tQD3TNvEDa3aQGnh-jQBPU",
   authDomain: "gebarel-hospital.firebaseapp.com",
   projectId: "gebarel-hospital",
   storageBucket: "gebarel-hospital.appspot.com",
   messagingSenderId: "57337443005",
   appId: "1:57337443005:web:d1b3e79c47fe1514033dd4",
   measurementId: "G-R61T9SX64S"
};
export default firebaseConfig;